import { FC, useEffect } from "react";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
import ModalComponent from "../../shared/base-components/Modal";
import TextField from "../../shared/base-components/TextField";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../../shared/base-components/Button";
import { MODAL_TYPES, RESPONSE_CODE } from "../../shared/models/Types";
import { successNotify } from "../../shared/utils/notifications";

import {
  ExpenseCategoryAddRequest,
  ExpenseCategoryAddSchema,
  ExpenseCategoryModalProps,
} from "./Expense.constants";
import {
  useExpenseCategoryAddMutation,
  useExpenseCategoryUpdateMutation,
} from "./Expense.actions";

const ExpenseCategoryModal: FC<ExpenseCategoryModalProps> = ({
  categoryData,
  isModalOpen,
  modalType,
  toggle,
  mutate,
}) => {
  const isEdit = modalType === MODAL_TYPES.UPDATE;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ExpenseCategoryAddRequest>({
    resolver: yupResolver(ExpenseCategoryAddSchema),
  });

  const {
    data,
    mutate: expenseCategoryAddMutate,
    isLoading,
  } = useExpenseCategoryAddMutation();

  const {
    data: updateData,
    mutate: ExpenseCategoryUpdate,
    isLoading: updateLoading,
  } = useExpenseCategoryUpdateMutation();

  const onSubmit: SubmitHandler<any> = (
    requestValues: ExpenseCategoryAddRequest
  ) => {
    isEdit
      ? ExpenseCategoryUpdate({ ...requestValues, id: categoryData.id })
      : expenseCategoryAddMutate(requestValues);
  };

  useEffect(() => {
    if (data?.status === RESPONSE_CODE.CREATED) {
      successNotify("Kategori başarılı bir şekilde oluşturuldu");
      toggle();

      mutate({});
    }
  }, [data]);

  useEffect(() => {
    if (updateData?.status === RESPONSE_CODE.SUCCESS_CODE) {
      successNotify("Kategori başarılı bir şekilde güncellendi");
      toggle();

      mutate({});
    }
  }, [updateData]);

  return (
    <ModalComponent
      header={isEdit ? "Gider Kategori  Güncelle" : "Gider Kategori Ekle"}
      description={
        isEdit
          ? "Gider Kategori Güncellemek için ilgili alanı düzeltip onaylayın"
          : "Gider Kategori eklemek için gerekli alanları doldurunuz."
      }
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Form onSubmit={handleSubmit(onSubmit)} className="custom-form mt-4 pt-2">
        <Row>
          <Col sm="12" md="12" lg="12">
            <FormGroup className="mb-3">
              <Label className="form-label">Kategori Adı</Label>
              <TextField
                control={control}
                name="name"
                defaultValue={isEdit ? categoryData?.name : ""}
                type="text"
                className="form-control"
                placeholder="Kategori adı"
                error={errors.name?.message}
              />
            </FormGroup>
          </Col>

          <Col md="12">
            <FormGroup className="mb-3">
              <Button
                loading={isEdit ? updateLoading : isLoading}
                text={isEdit ? "Kategori Güncelle" : "Kategori Ekle"}
                variant="primary"
              />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default ExpenseCategoryModal;
